import FormControl from '@mui/material/FormControl';
import FormHelperText, {
  formHelperTextClasses,
} from '@mui/material/FormHelperText';
import FormLabel, { formLabelClasses } from '@mui/material/FormLabel';
import MuiRadioGroup from '@mui/material/RadioGroup';
import { styled } from '@mui/material/styles';

import { RADIO_GROUP_GAP_PX } from 'ui/radio-group/radio-group.constants';
import type { RadioGroupSize } from 'ui/radio-group/radio-group.types';

interface GroupSizeOwnerState {
  groupSize: RadioGroupSize;
}

const LABEL_VARIANT = {
  medium: 'subtitle1',
  small: 'subtitle2',
} as const satisfies Record<RadioGroupSize, 'subtitle1' | 'subtitle2'>;

const shouldForwardProp = (prop: PropertyKey) => prop !== 'groupSize';

export const RadioGroupRoot = styled(FormControl, {
  shouldForwardProp,
})<GroupSizeOwnerState>(({ groupSize }) => ({
  gap: RADIO_GROUP_GAP_PX[groupSize].stack,
}));

export const RadioGroupLabel = styled(FormLabel, {
  shouldForwardProp,
})<GroupSizeOwnerState>(({ theme, groupSize }) => ({
  ...theme.typography[LABEL_VARIANT[groupSize]],
  color: theme.palette.text.primary,
  [`&.${formLabelClasses.focused}, &.${formLabelClasses.error}, &.${formLabelClasses.disabled}`]:
    {
      color: theme.palette.text.primary,
    },
  [`& .${formLabelClasses.asterisk}`]: {
    color: theme.palette.error.main,
  },
}));

export const RadioGroupOptions = styled(MuiRadioGroup, {
  shouldForwardProp,
})<GroupSizeOwnerState>(({ groupSize }) => ({
  alignItems: 'flex-start',
  gap: `${RADIO_GROUP_GAP_PX[groupSize].betweenRows}px ${RADIO_GROUP_GAP_PX[groupSize].betweenColumns}px`,
}));

export const RadioGroupHelperText = styled(FormHelperText)(({ theme }) => ({
  ...theme.typography.body2,
  margin: 0,
  color: theme.palette.text.primary,
  [`&.${formHelperTextClasses.disabled}`]: {
    color: theme.palette.text.primary,
  },
  [`&.${formHelperTextClasses.error}`]: {
    color: theme.palette.error.main,
  },
}));
